import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OEM_VENDOR = createActionTypes('FETCH_OEM_VENDOR');
export const GET_OEM_VENDOR = createActionTypes('GET_OEM_VENDOR');
export const CREATE_OEM_VENDOR = createActionTypes('CREATE_OEM_VENDOR');
export const UPDATE_OEM_VENDOR = createActionTypes('UPDATE_OEM_VENDOR');
export const DELETE_OEM_VENDOR = createActionTypes('DELETE_OEM_VENDOR');
